export default __webpack_public_path__ + "static/media/excel_big.a120aa6b.svg";